<template>
  <div class="app-container">
    <div class="filter-container">
      <el-button class="filter-item" type="primary" icon="el-icon-plus" @click='showAddDialog'>通知</el-button>

    </div>
    <el-table :data="list" v-loading="listLoading" border fit highlight-current-row style="width: 100%"  max-height="550">
      <el-table-column align="left" label="日期" width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.createdAt | parseTime('{y}-{m}-{d} {h}:{i}') }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="标题" width="300">
        <template slot-scope="scope">
          <span>{{ scope.row.subject }}</span>
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" align="left" label="状态" width="150">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status | statusFilter">{{ scope.row.status | statusDisplay }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column align="left" label="内容" min-width="300">
        <template slot-scope="scope">
          <span v-if="scope.row.isImage == false">{{ scope.row.content }}</span>
          <a v-if="scope.row.isImage == true" :href="scope.row.content" target="_blank"><img height=150
              :src="scope.row.content" /> </a>
        </template>
      </el-table-column>
      <el-table-column align="left" label="弹窗" width="200">
        <template slot-scope="scope">
          <span>{{ scope.row.isAlert ? '是' : '否' }}</span>
        </template>
      </el-table-column>

      <el-table-column align="left" label="操作" width="180" fixed="right">
        <template slot-scope="scope">
          <el-button type="warning" size="mini" @click="toDelete(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.limit"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>

    <el-dialog title="添加通知" :visible.sync="newDialogVisible" width="40%">
      <el-form ref="newForm" :model="newData" :rules="newFormRules" label-position="right" label-width="120px">
        <el-form-item label="通知标题" prop="title">
          <el-input style="width: 150px" v-model="newData.title" placeholder="请输入通知标题"></el-input>
        </el-form-item>
        <el-form-item label="通知类型">
          <el-radio-group v-model="newData.isImage" size="mini">
            <el-radio-button :label="false">文本</el-radio-button>
            <el-radio-button :label="true">图片</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="newData.isImage ? '选择图片' : '通知内容'" prop="content">
          <el-input v-if="newData.isImage == false" type="textarea" v-model="newData.content"
            placeholder="请输入通知内容"></el-input>
          <el-upload v-if="newData.isImage == true" accept=".jpg,.png" class="upload-demo" action
            :http-request="uploadRequest" :file-list="uploadFiles" :limit="1" :on-success="uploadSuccess"
            :on-remove="uploadRemove" :before-upload="uploadBefore">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="弹窗通知" prop="content">
          <el-switch v-model="newData.isAlert"></el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="newDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="doAdd">确定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import store from '@/store'
import oss from '@/utils/ali-oss';

export default {
  name: 'systemnotification',
  data() {
    return {
      list: null,
      total: 0,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10
      },
      roles: [],

      newDialogVisible: false,
      newData: {
        title: '',
        content: '',
        isAlert: false,
        isImage: false
      },
      newFormRules: {
        title: [{
          required: true,
          message: '请输入标题',
          trigger: 'blur'
        },
        {
          min: 1,
          message: '长度应最小1位',
          trigger: 'blur'
        }
        ],
        content: [{
          required: true,
          message: '内容不能为空',
          trigger: 'blur'
        },
        {
          min: 1,
          message: '长度应最小1位',
          trigger: 'blur'
        }
        ]
      },
      uploadFiles: [],
      uploadLoading: false
    }
  },
  filters: {
    statusFilter(status) {
      const statusMap = {
        0: 'info',
        1: 'success'
      }
      return statusMap[status]
    },
    statusDisplay(status) {
      const statusMap = {
        '0': '待发送',
        '1': '完成',
        '-1': '失败'
      }
      return statusMap[status]
    }
  },
  beforeRouteEnter(to, from, next) {
    next()
  },
  activated() {
    if (this.$route.meta.hasOwnProperty('redraw') && this.$route.meta.redraw) {
      this.doReset()
      this.$route.meta.redraw = false
    }
    if (
      this.$route.meta.hasOwnProperty('refresh') &&
      this.$route.meta.refresh
    ) {
      this.getList()
      this.$route.meta.refresh = false
    }
  },
  created() {
    this.doReset()
  },
  methods: {
    doReset() {
      this.list = null
      this.total = 0
      this.listLoading = true
      this.listQuery = {
        page: 1,
        limit: 10,
        title: '',
        content: ''
      }
      this.doSearch()
    },
    doSearch() {
      this.listQuery.page = 1
      this.getList()
    },
    getList() {
      this.listLoading = true
      var parent = this
      this.$httpAuth
        .post('/v1/backendSystemNotificationRpc/list', {
          pageStart: (this.listQuery.page - 1) * this.listQuery.limit,
          pageCount: this.listQuery.limit
        })
        .then(function (response) {
          parent.listLoading = false
          parent.list = response.data.data
          parent.total = response.data.total
        })
        .catch(() => {
          parent.listLoading = false
        })
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    toDelete(id) {
      this.$confirm('是否删除该数据?', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var parent = this
        this.$httpAuth
          .post('/v1/backendSystemNotificationRpc/delete', {
            id: id
          })
          .then(function (response) {
            parent.$message({
              message: '删除成功',
              type: 'success'
            })
            parent.getList()
          })
      })
    },
    showAddDialog() {
      this.newDialogVisible = true
      this.newData = {
        title: '',
        content: '',
        isAlert: false,
        isImage: false
      }
      this.uploadFiles = []
      this.newData.content = ''
      if (this.$refs['newForm']) {
        this.$refs['newForm'].resetFields()
      }
    },
    uploadBefore(file) {
      const isJPEG = file.type === 'image/jpeg'
      const isJPG = file.type === 'image/jpg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 < 500

      if (!isJPEG && !isJPG && !isPNG) {
        this.$message.error('请上传JPEG/JPG/PNG 的图片!')
      }
      if (!isLt2M) {
        this.$message.error('上传的封面图大小不能超过500K!')
      }
      return (isJPEG || isJPG || isPNG) && isLt2M
    },
    uploadRequest(option) {
      oss.ossUploadFile(option)
    },
    uploadSuccess(res, file) {
      this.newData.content = res;
    },

    uploadRemove(file, fileList) {
      this.newData.content = ''
    },
    doAdd() {
      this.$refs['newForm'].validate(valid => {
        if (valid) {
          var parent = this
          this.$httpAuth
            .post('/v1/backendSystemNotificationRpc/add', {
              subject: this.newData.title,
              content: this.newData.content,
              status: 0,
              isAlert: this.newData.isAlert,
              isImage: this.newData.isImage
            })
            .then(function (response) {
              parent.getList()
              parent.newDialogVisible = false
            })
            .catch(() => {
              parent.listLoading = false
            })
        }
      })
    }
  }
}
</script>

<style scoped>
.edit-input {
  padding-right: 100px;
}

.cancel-btn {
  position: absolute;
  right: 15px;
  top: 10px;
}
</style>
